module.exports = __webpack_public_path__ + "static/og-default-image-385bf6ea2911a65a77011a48100414d4.jpg";